<script lang="ts">
  import LetterRecipientTag from "../../../../_shared/_modules/letter-recipient-tag"
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import type { LetterDeliveryDecisionDraft, LetterDeliveryDecisionRow } from "../../contract"
  import {
    recipientChoiceOptionsForRow,
    recipientChoiceValueForState,
  } from "../../../../_shared/_logic/print-selection"
  import { buildLetterDeliveryRecipientDisplay } from "../../../../_shared/_logic/print-presentation"

  let props: InboxWorkflowCellProps<LetterDeliveryDecisionRow, LetterDeliveryDecisionDraft> =
    $props()

  const printRow = $derived(props.row)
  const state = $derived(props.draft)
  const recipientValue = $derived(recipientChoiceValueForState(state))
  const optionLabel = $derived(
    recipientChoiceOptionsForRow(printRow).find((option) => option.value === recipientValue)
      ?.name ?? "",
  )
  const recipientDisplay = $derived(
    buildLetterDeliveryRecipientDisplay({
      mode: state.mode,
      recipientName: state.recipientName ?? null,
      recipientOptionLabel: optionLabel,
      recipientAddress: state.recipientAddress ?? null,
      propertyAddress: state.propertyAddress ?? null,
    }),
  )
</script>

<LetterRecipientTag
  label={state.ignored ? "Kein Empfänger erforderlich" : recipientDisplay.label}
  address={state.ignored ? "" : recipientDisplay.addressLabel}
/>
